import React from 'react';
import { useHistory } from 'react-router-dom';
import '../dashboard/css/Article1.css';
import blogImage from '../dashboard/assets/Article.avif';
import blog1 from '../dashboard/assets/article5.webp';

const Article5 = () => {
  const history = useHistory();

  return (
    <div className="rsh-blog-section">
      {/* Hero */}
      <div
        className="rsh-blog-hero"
        style={{ backgroundImage: `url(${blogImage})` }}
      >
        <div className="rsh-blog-overlay">
          <h1 className="rsh-blog-title">Articles</h1>
          <p className="rsh-breadcrumb">
            <span onClick={() => history.push('/')}>Home</span> / Articles
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="rsh-blog-container">
        <h2 className="rsh-section-title">
          Why Home Tuition Is Better Than Coaching Classes in Ahmedabad
        </h2>

        <div className="rsh-published-badge">
          Published on: 05 January 2026
        </div>

        <img
          src={blog1}
          alt="Why Home Tuition Is Better Than Coaching Classes in Ahmedabad"
          className="rsh-blog-detail-img"
        />

        <div className="rsh-blog-detail-content">
          <p className="intro-text">
            In a competitive education-driven city like Ahmedabad, parents are
            constantly evaluating the best learning options for their children.
            While coaching institutes have traditionally been popular, home
            tuition is increasingly proving to be a more effective and
            student-focused alternative.
          </p>

          <p>
            From CBSE and ICSE to Gujarat Board and competitive exams, students
            in Ahmedabad are benefiting greatly from personalized home tuition.
            This article explains why home tuition often delivers better results
            than crowded coaching classes.
          </p>

          {/* REASON 1 */}
          <div className="info-box">
            <h3>1. Personalized One-to-One Attention</h3>
            <p>
              In coaching institutes, teachers must manage large batches of
              students, making individual attention difficult. Home tuition, on
              the other hand, focuses entirely on one student.
            </p>
            <ul>
              <li>Customized teaching pace</li>
              <li>Immediate doubt clarification</li>
              <li>Focused improvement on weak areas</li>
            </ul>
          </div>

          {/* REASON 2 */}
          <div className="info-box">
            <h3>2. Flexible Timings and Convenience</h3>
            <p>
              Ahmedabad students often juggle school, homework, exams, and
              extracurricular activities. Home tuition offers flexible
              scheduling that coaching institutes cannot match.
            </p>
            <ul>
              <li>No travel time or traffic stress</li>
              <li>Classes scheduled as per student routine</li>
              <li>Better time management</li>
            </ul>
          </div>

          {/* REASON 3 */}
          <div className="info-box">
            <h3>3. Comfortable Learning Environment</h3>
            <p>
              Learning at home allows students to study in a familiar and
              stress-free environment, improving concentration and retention.
            </p>
          </div>

          {/* REASON 4 */}
          <div className="info-box">
            <h3>4. Better Parent Involvement and Monitoring</h3>
            <p>
              Home tuition allows parents to stay informed about their child’s
              progress, attendance, and performance—something rarely possible
              with coaching institutes.
            </p>
          </div>

          {/* COMPARISON TABLE */}
          <h3 className="table-title">
            Home Tuition vs Coaching Classes in Ahmedabad
          </h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Factor</th>
                  <th>Home Tuition</th>
                  <th>Coaching Classes</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Class Size</td>
                  <td>1-on-1 or small group</td>
                  <td>20–50 students</td>
                </tr>
                <tr>
                  <td>Attention Level</td>
                  <td>High</td>
                  <td>Limited</td>
                </tr>
                <tr>
                  <td>Learning Pace</td>
                  <td>Customized</td>
                  <td>Fixed</td>
                </tr>
                <tr>
                  <td>Travel Requirement</td>
                  <td>No</td>
                  <td>Yes</td>
                </tr>
                <tr>
                  <td>Parent Monitoring</td>
                  <td>High</td>
                  <td>Low</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* COST */}
          <div className="info-box">
            <h3>5. Cost-Effective in the Long Run</h3>
            <p>
              While coaching institutes may appear cheaper initially, home
              tuition often delivers better academic results in less time,
              making it a cost-effective investment for Ahmedabad parents.
            </p>
          </div>

          {/* FINAL */}
          <div className="info-box">
            <h3>Final Verdict</h3>
            <p>
              For students in Ahmedabad who need focused attention, flexible
              schedules, and measurable academic improvement, home tuition is a
              superior choice compared to traditional coaching classes. With
              the right tutor, students can build confidence, improve grades,
              and achieve long-term academic success.
            </p>
          </div>

          <div className="rsh-back-btn-wrapper">
            <button
              className="rsh-back-btn"
              onClick={() => history.push('/index')}
            >
              Go Back To Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article5;